import { defineMessages } from 'react-intl';

const messages = defineMessages({
  genericErrorMsg: {
    description: 'logine page generic error message',
    defaultMessage:
      'The username or password you entered was invalid. Please note that repeated failed attempts will result in your account being locked out.',
    id: 'PjTjKS',
  },
  sessionExpired: {
    description: 'Login session expired',
    defaultMessage: 'You have been logged out due to inactivity. Check “Keep me logged in” to stay logged in for 30 days.',
    id: 'Tus6wd',
  },
  noData: {
    description: 'Login no data',
    defaultMessage: 'Unable to communicate with the server.',
    id: 'XxkK/C',
  },
  unverified: {
    description: 'login email unverified',
    defaultMessage: "You're unverified. We'll support this case in the future",
    id: 'RlCNFd',
  },
  verificationSuccessful: {
    description: 'Message indicating successful email verification',
    defaultMessage: 'Your account has been successfully verified.',
    id: '9RGxxr',
  },
  loginBtnText: {
    description: 'login button title',
    defaultMessage: 'Login',
    id: 'm9Paql',
  },
  forgotPassword: {
    description: 'forgot password text',
    defaultMessage: 'Forgot my password',
    id: '9r/aQ4',
  },
  tryShipstation: {
    description: 'try shipstation link',
    defaultMessage: 'Try ShipStation',
    id: 'XI0KG5',
  },
  logIntoShipstation: {
    description: 'log into shipstation text',
    defaultMessage: 'Log into ShipStation',
    id: 'Nwz/oN',
  },
  password: {
    description: 'login password',
    defaultMessage: 'Password',
    id: 'mwL583',
  },
  username: {
    description: 'login username',
    defaultMessage: 'Username/Email Address',
    id: '4Pr+kJ',
  },
  rememberMe: {
    description: 'login text for remember me checkbox',
    defaultMessage: 'Keep me logged in',
    id: 'Y+NB6D',
  },
  systemDownMessage: {
    description: 'Error message when ShipStation is down',
    defaultMessage:
      'We are having trouble logging you in. Please try again. If you receive this message multiple times, please check our system status at <status>https://status.shipstation.com</status>. If you need assistance, or have questions for our team, please send an email to <support>support@shipstation.com</support>.',
    id: 'CDx7f+',
  },
  signupRedirectMessage: {
    description: 'informational message when a user signs up for ShipStation from our marketing site and then is redirected to ShipStation',
    defaultMessage: "Congratulations! You've successfully created your account.",
    id: 'K9l1GM',
  },
  sellerMaintenanceLogoutMessage: {
    description: 'seller can see this displayed on the login page if they were forcibly logged out for maintenance',
    defaultMessage:
      'Your account is currently undergoing maintenance and we needed to log you out. The maintenance is scheduled for up to two hours, but we will work to keep the maintenance window as short as possible. After maintenance is complete, please deactivate and log into ShipStation Connect again to resume normal usage.',
    id: 'iEAAfB',
  },
});

export default messages;
